import { createSelector } from '@reduxjs/toolkit';

import { isConnectingSelector } from 'src/selectors/isConnecting';
import { ConnectionStatus } from 'src/store/connections/types';
import { ReduxState } from 'src/store/types';

export const isConnectedSelector = createSelector(
  isConnectingSelector,
  (state: ReduxState) => state.connections.status === ConnectionStatus.SUCCESS,
  (isConnecting, isConnected) => !isConnecting && isConnected
);
